import { SlidersHorizontal, TrendingUp, Clock } from 'lucide-react'
import type { Category, SortOption } from '../../../types/word-discovery'

interface FilterBarProps {
  categories: Category[]
  selectedCategoryId: string | null
  sortBy: SortOption
  onFilterCategory?: (categoryId: string | null) => void
  onSort?: (sortBy: SortOption) => void
}

export function FilterBar({
  categories,
  selectedCategoryId,
  sortBy,
  onFilterCategory,
  onSort,
}: FilterBarProps) {
  return (
    <div className="max-w-7xl mx-auto px-6 py-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Category Filter */}
        <div className="flex items-center gap-2 flex-1">
          <SlidersHorizontal className="w-4 h-4 text-slate-400" />
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => onFilterCategory?.(null)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                selectedCategoryId === null
                  ? 'bg-amber-500 text-slate-900'
                  : 'bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-amber-500'
              }`}
            >
              الكل
            </button>
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => onFilterCategory?.(category.id)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                  selectedCategoryId === category.id
                    ? 'bg-amber-500 text-slate-900'
                    : 'bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-amber-500'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Sort Controls */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => onSort?.('popularity')}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
              sortBy === 'popularity'
                ? 'bg-rose-500 text-white'
                : 'bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-rose-500'
            }`}
          >
            <TrendingUp className="w-4 h-4" />
            <span>الأشهر</span>
          </button>
          <button
            onClick={() => onSort?.('newest')}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
              sortBy === 'newest'
                ? 'bg-rose-500 text-white'
                : 'bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-rose-500'
            }`}
          >
            <Clock className="w-4 h-4" />
            <span>الأحدث</span>
          </button>
        </div>
      </div>
    </div>
  )
}
